export const ROUTES = {
  DASHBOARD: "/chats",
  BUSINESS: "/business",
  PROFILE: "/profile",
  POSTER: "/poster",
  TOPICS: "/topics",
  CHATS: "/chats",
  USERS: "/users",
  CALENDAR: "/calendar",
  ADVISOR: "/advisor",
  TEAM: "/team",
  MEETING_ROOM: "/meeting-room",
  SIGNIN: "/auth/signin",
  SIGNUP: "/auth/signup",
  NOT_FOUND: "/404",
};
